export default __webpack_public_path__ + "static/drnis-dceb8fd4fb6628e175383b76404cfd17.png";